import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '@/environments/environment';
import {PublicProfile} from '@/app/core/models/public-profile.model';
import {ProfileCompare} from '@/app/core/models/profile-compare.model';

@Injectable({
	providedIn: 'root'
})
export class PublicProfileService {

	private readonly SERVICE_URI = `${environment.backendUrl}/profile`;

	private readonly http: HttpClient = inject(HttpClient);

	getPublicProfile(username: string): Observable<PublicProfile> {
		return this.http.get<PublicProfile>(`${this.SERVICE_URI}/${username}`);
	}

	/** Réservé aux joueurs connectés (401/403 sinon) — cf. token-interceptor.service.ts pour l'attache du Bearer token sur cette route. */
	compareProfiles(username: string): Observable<ProfileCompare> {
		return this.http.get<ProfileCompare>(`${this.SERVICE_URI}/${username}/compare`);
	}
}
